import PropTypes from 'prop-types'

import style from '@aytm/app/stats/page/question-views/components/styles/Controls.module.scss'
import mnStyle from '@aytm/app/stats/page/question-views/mn/Controls.module.scss'

const Controls = ({ title, collapsed, onToggle, children }) => (
  <div className={`${style.component} ${mnStyle.controls}`}>
    <span className={`p-field ${mnStyle.label}`}>{title}</span>
    {children}
    <span className={`${mnStyle.link} p-right`} onClick={() => onToggle(!collapsed)}>
      {collapsed ? 'Expand' : 'Collapse'}
    </span>
  </div>
)

Controls.propTypes = {
  title: PropTypes.string,
  collapsed: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node
}

Controls.displayName = 'Controls'

export default Controls
